import LegalLayout from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      title="Conditions Générales d'Utilisation"
      subtitle="Dernière mise à jour : 26 juin 2026"
      testId="terms-page"
    >
      <h2>1. Préambule</h2>
      <p>
        Les présentes Conditions Générales d&apos;Utilisation (« CGU ») régissent l&apos;accès et l&apos;usage de la
        plateforme <strong>AfriMeet</strong> (le « Service »), éditée par <strong>AfriMeet</strong>, accessible
        à l&apos;adresse <a href="https://afrimeet.org">afrimeet.org</a>. Toute utilisation du Service
        emporte acceptation pleine et entière des présentes.
      </p>

      <h2>2. Description du Service</h2>
      <p>
        AfriMeet est une plateforme SaaS qui permet aux entreprises africaines d&apos;enregistrer leurs
        réunions, d&apos;obtenir une transcription automatique (français / anglais) et un résumé exécutif
        généré par intelligence artificielle, puis de distribuer le compte-rendu aux participants par email.
      </p>

      <h2>3. Création du compte</h2>
      <ul>
        <li>L&apos;inscription est ouverte à toute personne physique majeure agissant pour le compte d&apos;une entité légale.</li>
        <li>L&apos;Utilisateur s&apos;engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants.</li>
        <li>Une seule session active par utilisateur est autorisée. La connexion sur un nouvel appareil déconnecte automatiquement la session précédente.</li>
      </ul>

      <h2>4. Offres et tarification</h2>
      <ul>
        <li><strong>Plan Gratuit</strong> : 2 réunions maximum, durée illimitée par réunion (jusqu&apos;à 2 heures).</li>
        <li><strong>Plan Business</strong> : <strong>35 000 FCFA / mois</strong> (TTC). Réunions illimitées, support prioritaire, recherche intelligente, archivage.</li>
        <li>Tous les prix sont libellés en Franc CFA (XOF) et facturés mensuellement. Le paiement s&apos;effectue par carte bancaire (Stripe).</li>
        <li>Toute mensualité entamée est due. Le service est résiliable à tout moment ; il reste actif jusqu&apos;au terme de la période payée.</li>
      </ul>

      <h2>5. Obligations de l&apos;Utilisateur</h2>
      <p>L&apos;Utilisateur s&apos;engage à :</p>
      <ul>
        <li>n&apos;enregistrer que des réunions auxquelles il participe légitimement et à en informer les participants conformément à la législation applicable ;</li>
        <li>ne pas téléverser de contenu illicite, contrefaisant, diffamatoire ou portant atteinte à la vie privée d&apos;un tiers ;</li>
        <li>ne pas tenter d&apos;accéder aux comptes d&apos;autrui ni de contourner les mécanismes de sécurité.</li>
      </ul>

      <h2>6. Propriété intellectuelle</h2>
      <p>
        Les contenus audio, transcriptions et résumés générés depuis le compte de l&apos;Utilisateur restent
        sa propriété exclusive. AfriMeet conserve la propriété de la plateforme, des modèles d&apos;IA, du
        code source et des éléments graphiques.
      </p>

      <h2>7. Disponibilité et limites techniques</h2>
      <p>
        AfriMeet s&apos;efforce d&apos;assurer une disponibilité du Service 24h/24, 7j/7. Toutefois, des
        opérations de maintenance, des incidents tiers (OpenAI, Stripe, Resend, hébergement) ou des cas de
        force majeure peuvent occasionner des interruptions. La durée maximale d&apos;une réunion traitée
        par le Service est de 2 heures.
      </p>

      <h2>8. Responsabilité</h2>
      <p>
        AfriMeet ne saurait être tenu responsable de la qualité de la transcription au-delà d&apos;un seuil
        de précision indicatif de 85 %, ni d&apos;erreurs ou omissions dans les résumés générés par IA. Il
        appartient à l&apos;Utilisateur de relire les contenus avant diffusion. La responsabilité d&apos;AfriMeet
        est en tout état de cause limitée au montant des sommes effectivement versées par l&apos;Utilisateur
        au cours des 12 derniers mois.
      </p>

      <h2>9. Résiliation</h2>
      <p>
        L&apos;Utilisateur peut résilier son compte à tout moment depuis la page <em>Paramètres</em>. AfriMeet
        se réserve le droit de suspendre ou résilier sans préavis un compte en cas de violation des présentes,
        de fraude ou d&apos;impayé.
      </p>

      <h2>10. Modification des CGU</h2>
      <p>
        AfriMeet peut modifier les présentes CGU à tout moment. Les Utilisateurs seront informés par email
        au moins 15 jours avant l&apos;entrée en vigueur de toute modification substantielle.
      </p>

      <h2>11. Droit applicable et juridiction</h2>
      <p>
        Les présentes sont régies par le droit applicable au siège social d&apos;AfriMeet. Tout litige relève
        de la compétence exclusive des tribunaux du siège, après tentative de résolution amiable.
      </p>
    </LegalLayout>
  );
}
